export default __webpack_public_path__ + "static/media/promoMob.0b8c8c52.svg";